import { render, staticRenderFns } from "./CreateEditAgentQuota.vue?vue&type=template&id=6326770c&"
import script from "./CreateEditAgentQuota.vue?vue&type=script&lang=js&"
export * from "./CreateEditAgentQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports